import { useMemo,useState,useContext } from "react";
import { Stack, IconButton } from "@fluentui/react";
import DOMPurify from "dompurify";
import { FontIcon,Text } from "@fluentui/react";
import styles from "./Answer.module.css";
import { AppStateContext } from "../state/AppProvider";
import { AskResponse, getCitationFilePath } from "../../api";
import { parseAnswerToHtml } from "./AnswerParser";
import { AnswerIcon } from "./AnswerIcon";
import { Document, Packer, Paragraph, Table, TableCell, TableRow, WidthType, TextRun } from "docx";
import { saveAs } from 'file-saver';
import { toast } from 'react-toastify';


import jsPDF from 'jspdf';


interface Props {
    id: number;
    answer: AskResponse;
    isSelected?: boolean;
    onCitationClicked: (filePath: string) => void;
    onThoughtProcessClicked: () => void;
    onSupportingContentClicked: () => void;
    onFollowupQuestionClicked?: (question: string) => void;
    showFollowupQuestions?: boolean;
}

export const Answer = ({
    id,
    answer,
    isSelected,
    onCitationClicked,
    onThoughtProcessClicked,
    onSupportingContentClicked,
    onFollowupQuestionClicked,
    showFollowupQuestions
}: Props) => {
    const parsedAnswer = useMemo(() => parseAnswerToHtml(answer.answer, onCitationClicked), [answer]);
    const appStateContext = useContext(AppStateContext)
    const sanitizedAnswerHtml = DOMPurify.sanitize(parsedAnswer.answerHtml);
    const [hascommentedPositive, sethascommentedPositive] = useState<boolean>(false);
    const [hascommentedNegative, sethascommentedNegative] = useState<boolean>(false);
    const handleUperhandClick = () => {
        appStateContext?.dispatch({ type: 'TOGGLE_LIKE_MODAL', payload: true });
        appStateContext?.dispatch({ type: 'SET_Message_Selected', payload: id });
        sethascommentedPositive(true)
    };
    const handleLowerhandClick = () => {
        appStateContext?.dispatch({ type: 'SET_DISIKE_MODAL', payload: true });
        appStateContext?.dispatch({ type: 'SET_Message_Selected', payload: id });
        sethascommentedNegative(true)
    };
    const copiaralportapapeles = () => {
       
        const element = document.createElement("div");
        element.innerHTML = sanitizedAnswerHtml;
    
        // Selecciona la tabla y aplica los estilos en línea
        const table = element.querySelector("table");
        if (table) {
            table.style.margin = "20px auto";
            table.style.width = "190px";
            table.style.fontFamily = "'Poppins', sans-serif";
        }
    
        // Aplica estilos a las celdas th
        const thElements = element.querySelectorAll("th");
        thElements.forEach(th => {
            th.style.background = "#6fa09a";
            th.style.color = "white";
            th.style.fontWeight = "900";
        });
    
        // Aplica estilos a las celdas td
        const tdElements = element.querySelectorAll("td");
        tdElements.forEach(td => {
            td.style.verticalAlign = "top";
            td.style.background = "#eeeded";
            td.style.padding = "2px 6px";
        });
    
        const styledHtml = element.innerHTML;
    
        navigator.clipboard.write([
            new ClipboardItem({
                "text/html": new Blob([styledHtml], { type: "text/html" }),
                "text/plain": new Blob([styledHtml], { type: "text/plain" })
            })
        ]);
        toast.success('Copiado al portapapeles', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light"
            });
    }

   
    const descargarDocumentoDocx = () => {
        const element = document.createElement("div");
        element.innerHTML = sanitizedAnswerHtml;
    
        const children = element.childNodes;
        const docContent: any = [];
    
        children.forEach((child:any) => {
            if (child.nodeType === Node.TEXT_NODE && child.textContent!.trim()) {
                // Agregar texto como párrafo
                docContent.push(new Paragraph({
                    children: [new TextRun(child.textContent!.trim())],
                }));
            } else if (child.nodeName.toLowerCase() === "table") {
                // Procesar tabla
                const rows = Array.from(child.querySelectorAll("tr")).map((rowElement:any) => {
                    const cells = Array.from(rowElement.children).map((cellElement:any) => {
                        return new TableCell({
                            children: [
                                new Paragraph({
                                    children: [new TextRun(cellElement.textContent || "")]
                                })
                            ],
                            margins: { top: 100, bottom: 100, left: 100, right: 100 },
                            shading: {
                                fill: cellElement.tagName.toLowerCase() === 'th' ? "6fa09a" : "eeeded"
                            },
                            verticalAlign: "top",
                            width: {
                                size: 100,
                                type: WidthType.PERCENTAGE,
                            },
                        });
                    });
    
                    return new TableRow({
                        children: cells,
                    });
                });
    
                const table = new Table({
                    rows: rows,
                    width: {
                        size: 90,
                        type: WidthType.PERCENTAGE,
                    },
                });
    
                docContent.push(table);
            }
        });
    
        // Crear el documento con el contenido procesado
        const doc = new Document({
            sections: [
                {
                    children: docContent,
                },
            ],
        });
    
        // Guardar el documento como .docx
        Packer.toBlob(doc).then(blob => {
            saveAs(blob, "documento.docx");
        });
    };
    const descargardocumento = async () => {
        descargarDocumentoDocx();
        // const htmlString = sanitizedAnswerHtml;
        // const doc = new jsPDF();
        // doc.html(htmlString, {
        //     x: 10,
        //     y: 10,
        //     width: 190, // Ajustar el ancho de contenido
        //     windowWidth: 800, // Ajustar el ancho de la ventana para la renderización
        //     callback: function (doc) {
        //         doc.save('answer.pdf');
        //     },
        // });
    };
    return (
        <Stack className={`${styles.answerContainer} ${isSelected && styles.selected}`} verticalAlign="space-between">
            <Stack.Item>
                <Stack horizontal horizontalAlign="space-between">
                    <AnswerIcon />
                    <div>
                    <IconButton
                            style={{ color: "black" }}
                            iconProps={{ iconName: "Copy"}}
                            title="Show thought process"
                            ariaLabel="Show thought process"
                            onClick={() => copiaralportapapeles()}
                            disabled={!answer.thoughts}
                        />
                    <IconButton
                            style={{ color: "black" }}
                            iconProps={{ iconName: "Download"}}
                            title="Show thought process"
                            ariaLabel="Show thought process"
                            onClick={() => descargardocumento()}
                            disabled={!answer.thoughts}
                    />
                        {/*<IconButton
                            style={{ color: "black" }}
                            iconProps={{ iconName: "Lightbulb" }}
                            title="Show thought process"
                            ariaLabel="Show thought process"
                            onClick={() => onThoughtProcessClicked()}
                            disabled={!answer.thoughts}
                        />
                        <IconButton
                            style={{ color: "black" }}
                            iconProps={{ iconName: "ClipboardList" }}
                            title="Show supporting content"
                            ariaLabel="Show supporting content"
                            onClick={() => onSupportingContentClicked()}
                            disabled={!answer.data_points.length}
                        />*/}
                        {(() => { 
            if (!hascommentedPositive && !hascommentedNegative) {
                return(
                    <>
                        <IconButton
                            style={{ color: "green" }}
                            iconProps={{ iconName: "like" }}
                            title="Like content"
                            ariaLabel="Like content"
                            onClick={() => {handleUperhandClick();}}
                            disabled={false}
                        />
                        <IconButton
                            style={{ color: "red" }}
                            iconProps={{ iconName: "dislike" }}
                            title="Dislike content"
                            ariaLabel="Dislike content"
                            onClick={() => {handleLowerhandClick();}}
                            disabled={false}
                        />
                    </>
                );
            }else if(hascommentedPositive){
                return(
                    <>
                        <IconButton
                            style={{ color: "green" }}
                            iconProps={{ iconName: "like" }}
                            title="Like content"
                            ariaLabel="Like content"
                            onClick={() => {handleUperhandClick();}}
                            disabled={true}
                        />
                    </>
                );
            }else{
                return(
                    <>
                        <IconButton
                            style={{ color: "red" }}
                            iconProps={{ iconName: "dislike" }}
                            title="Dislike content"
                            ariaLabel="Dislike content"
                            onClick={() => {handleLowerhandClick();}}
                            disabled={true}
                        />
                    </>
                );
            }
                        })()}
                         
                    </div>
                </Stack>
            </Stack.Item>
            <Stack.Item grow>
                <div className={styles.answerText} dangerouslySetInnerHTML={{ __html: sanitizedAnswerHtml }}></div>
            </Stack.Item>

            {!!parsedAnswer.citations.length && (
                <Stack.Item>
                    <Stack horizontal wrap tokens={{ childrenGap: 5 }}>
                        <span className={styles.citationLearnMore}>Citations:</span>
                        {parsedAnswer.citations.map((x, i) => {
                            const path = getCitationFilePath(x);
                            return (
                                <a key={i} className={styles.citation} title={x} onClick={() => onCitationClicked(path)}>
                                    {`${++i}. ${x}`}
                                </a>
                            );
                        })}
                    </Stack>
                </Stack.Item>
            )}

            {!!parsedAnswer.followupQuestions.length && showFollowupQuestions && onFollowupQuestionClicked && (
                <Stack.Item>
                    <Stack horizontal wrap className={`${!!parsedAnswer.citations.length ? styles.followupQuestionsList : ""}`} tokens={{ childrenGap: 6 }}>
                        <span className={styles.followupQuestionLearnMore}>Follow-up questions:</span>
                        {parsedAnswer.followupQuestions.map((x, i) => {
                            return (
                                <a key={i} className={styles.followupQuestion} title={x} onClick={() => onFollowupQuestionClicked(x)}>
                                    {`${x}`}
                                </a>
                            );
                        })}
                    </Stack>
                </Stack.Item>
            )}
        </Stack>
    );
};



